import DocViewer, { DocViewerRenderers, IDocument } from "react-doc-viewer";
import XLSXViewer from "./XLSXViewer";
import DOCXViewer from "./DOCXViewer";
import SVGViewer from "./SVGViewer";
import CSVViewer from "./CSVViewer";
import PDFViewer from "./PDFViewer";
import { useMemo } from "react";
import NoDocumentAvailable from "@styles/all-images/images/no-document-available.png";

const DocViewerComponent = ({ documents }: { documents: IDocument[] }) => {
  const customRenderers = [
    ...DocViewerRenderers,
    XLSXViewer,
    DOCXViewer,
    SVGViewer,
    CSVViewer,
    PDFViewer,
  ];

  const isNoDocumentAvailable = useMemo(() => {
    return documents.some((doc) => doc.fileType === "");
  }, [documents]);

  return isNoDocumentAvailable ? (
    <div className="tw-w-full tw-h-[60vh] tw-flex tw-items-center tw-justify-center">
      <div className="tw-flex tw-h-[500px] tw-w-[500px] tw-flex-col tw-items-center tw-justify-center tw-gap-2">
        <img src={NoDocumentAvailable} alt="No Document Available" />
      </div>
    </div>
  ) : (
    <DocViewer
      documents={documents}
      pluginRenderers={customRenderers}
      style={{ height: 800 }}
      config={{
        header: {
          disableFileName: true,
          retainURLParams: true,
        },
      }}
      theme={{
        primary: "#146C94",
        secondary: "#ffffff",
        tertiary: "#146C94",
        text_primary: "#ffffff",
        text_secondary: "#232323",
        text_tertiary: "#00000099",
      }}
    />
  );
};

export default DocViewerComponent;
